import { IStackItemProps, IStackProps, Stack } from '@fluentui/react/lib/Stack';

export interface IPStackProps extends IStackProps {}
export interface IPStackItemProps extends IStackItemProps {}

export type IPAlignment =
  | 'start'
  | 'end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'baseline'
  | 'stretch';

export const IPStack = (props: IPStackProps) => {
  return <Stack {...props} />;
};

// Re-export Stack.Item as IPStack.Item
IPStack.Item = Stack.Item;
